import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { AUTH_EVENTS } from '@/auth/values/auth.values';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-register-agreement'
})
export default class EdRegisterAgreementComponent extends Vue {
  
  /* Props */
  @Prop() readonly userType: any;

  /* Data */
  public saving: boolean = false;
  public acceptTerms: any = EdInputModel('acceptTerms', false, {}, true);
  public terms: any = {}

  /* Computed */
  get termsText() {
    return this.$i18n.locale == 'es' ? this.terms.bodySpanish : this.terms.bodyEnglish
  }

  /* Methods */
  confirm () {
    this.saving = true;
    this.$emit(AUTH_EVENTS.CONFIRM_TERMS, {termsId: this.terms.id, acceptTerms: this.acceptTerms.value});
    setTimeout(() => {
      this.saving = false;
    }, 3000)
  }

  goToInit () {
    this.$edEventBus.$emit(AUTH_EVENTS.ON_CHANGE_REGISTER_STEP, {step: 1, userType: this.userType})
  }

  goToPrevStep() {
    this.$edEventBus.$emit(AUTH_EVENTS.ON_CHANGE_REGISTER_STEP, {step: 3, userType: this.userType})
  }

  async created() {
    this.terms = await this.$Auth.Services.getTerms();
  }
}
